import React from 'react';
import { config } from './../config';

// Store
import SessionStore from '../stores/SessionStore';

// Dependencies
import moment from 'moment';

// Unauthenticated redirect
export function isAuthenticated() {
  let token = null;

  if(SessionStore.hasSessionStorage) {
    token = sessionStorage.getItem('token');
  } else {
    token = getCookie('token');
  }

  if(token === null || typeof token === 'undefined') {
    return false;
  }

  document.querySelector('body').className = document.querySelector('body').className.replace('logged-out', '');

  return true;
}

// Open and close drawers
export function toggleDrawer(e, component, drawerContent) {
  if(e) {
    e.preventDefault();
  }

  if(component){
    component.setState({
      drawerOpen: true,
      drawerContent
    }, function(){
      const drawer = document.querySelector('.drawer');

      if(drawer) {
        drawer.focus();
      }
    });
  }
  else{
    const drawer = document.querySelector('.drawer');
    if(drawer) drawer.focus();
  }

}

export function closeDrawer(e, component, closePath, callback) {
  if(e) {
    e.preventDefault();
  }

  document.querySelector('body').classList.remove('drawer-open');

  // Wait for the drawer to slide out before updating the URL
  // or running a function

  setTimeout(function () {
    if(component) {
      component.setState({
        drawerOpen: false,
        drawerContent: null
      });
    }


    if(closePath && component) {
      if(closePath[0] !== '/'){
        component.props.routing.history.push(`/${closePath}`);
      }
      else {
        component.props.routing.history.push(closePath);

      }
    }

    if(callback) {
      callback();
    }

    // Make sure the close button will show up the next time a drawer opens
    SessionStore.hideDrawerClose = false;
    document.querySelector('body').classList.remove('drawer-open');
    document.querySelector('body').classList.remove('drawer-open');
  }, 250);

  // Focus the main content
  setTimeout(function(){
    const content = document.querySelector('#main-content');

    if(content) {
      content.focus();
    }
  })
}

/**
 * Check form validity before submission
 *
 * @function checkValidity
 * @param {Event} e
 * @param {function} onValid
 * @param {function} onInvalid
 */
export function checkValidityHybrid(e, onValid, onInvalid = null) {
  e.preventDefault();

  const form = e.target;
  let invalidFields = [];
  const existingErrorMsg = form.querySelector('.error');

  // Mark the form as submitted
  form.classList.add('hybrid-form--submitted');

  let ie = document.querySelector('html').className.indexOf('ie-true') > -1 ? true : false;
  let oldMoz = navigator.userAgent.indexOf('Firefox') && parseInt(navigator.userAgent.slice(-4), 10) < 51 ? true : false;
  let edge = false;

  if(navigator.userAgent.indexOf('Edge/14') > -1 ||
      navigator.userAgent.indexOf('Edge/15') > -1 ||
      navigator.userAgent.indexOf('Edge/16') > -1 ||
      navigator.userAgent.indexOf('Edge/17') > -1) {
    edge = true;
  }

  // Old versions of Firefox and IE don’t support one of the invalid selectors used below
  if(!ie && !oldMoz && !edge) {
    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], input[aria-invalid="true"]:not(:placeholder-shown), select[aria-invalid="true"');
  } else if(edge) {
    invalidFields = form.querySelectorAll('input[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], select[aria-invalid="true"');
  } else {
    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], select[aria-invalid="true"');
  }

  // Remove existing error messages
  if(existingErrorMsg) {
    existingErrorMsg.parentNode.removeChild(existingErrorMsg);
  }

  if(!invalidFields.length) {
    // If everything is valid proceed
    if(onValid) {
      onValid(e);
    }
  } else {
    /**
     * Create a static list of invalid fields and direct focus to it.
     * Use this method instead of aria-live or role=alert. To use this
     * feature, all form inputs MUST have a valid label associated.
     */
    const errorMsg = document.createElement('div');
    errorMsg.className = 'error';
    errorMsg.setAttribute('tabIndex', '-1');

    const errorMsgNote = document.createElement('p');
    errorMsgNote.innerText = 'Sorry, your form contained errors. Please correct the problems before submitting.';

    const errorMsgList = document.createElement('ul');

    invalidFields.forEach(field => {
      const errorMsgListItem = document.createElement('li');
      const label = form.querySelector(`[for="${field.id}"]`);

      errorMsgListItem.innerText = field.getAttribute('data-errormsg') || label.innerText;

      errorMsgList.appendChild(errorMsgListItem);
    });

    errorMsg.appendChild(errorMsgNote).appendChild(errorMsgList);

    const fields = form.querySelector('.hybrid-form__fields:first-of-type');
    const fieldsParent = fields.parentNode;

    fieldsParent.insertBefore(errorMsg, fields);
    errorMsg.focus();

    if(onInvalid) {
      onInvalid(e);
    }
  }
}

// Check form validity before submission
export function checkValidity(e, submitFunction, selector, invalidCallback) {
  e.preventDefault();

  let form = null;

  if (selector) {
    form = document.querySelector(selector);
  } else {
    form = e.target;
  }

  form.classList.add('submitted');

  let ie = false;
  let oldMoz = false;
  let safari = false;
  let edge = false;
  let puffin = false;
  let invalidFields = [];

  if(document.querySelector('html').className.indexOf('ie-true') > -1) {
    ie = true;
  }

  if(navigator.userAgent.indexOf('Firefox') && parseInt(navigator.userAgent.slice(-4), 10) < 51) {
    oldMoz = true;
  }

  if(navigator.userAgent.indexOf('Safari')) {
    safari = true;
  }

  if(
      navigator.userAgent.indexOf('Edge/14') > -1 ||
      navigator.userAgent.indexOf('Edge/15') > -1 ||
      navigator.userAgent.indexOf('Edge/16') > -1 ||
      navigator.userAgent.indexOf('Edge/17') > -1
    ) {
    edge = true;
  }

  if(navigator.userAgent.indexOf('Puffin') > -1) {
    puffin = true;
  }

  // Old versions of Firefox and IE don’t support one of the invalid selectors used below
  if(!ie && !oldMoz && !edge && !puffin && !safari) {
    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], input[aria-invalid="true"]:not(:placeholder-shown)');
  } else if(edge) {
    invalidFields = form.querySelectorAll('input[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]');
  } else {
    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]');
  }

  if (!invalidFields.length) {
    if (submitFunction) {
      submitFunction(e);
    }

    // Remove error message
    let existingErrorMsg = form.querySelector('.note--error');

    if(existingErrorMsg) {
      existingErrorMsg.parentNode.removeChild(existingErrorMsg);
    }
  } else {
    let existingErrorMsg = form.querySelector('.note--error');

    if (!existingErrorMsg) {
      let errorMsg = document.createElement('SPAN');
      errorMsg.className = 'note note--prominent note--error';
      errorMsg.innerHTML = 'Sorry, your form contained errors. Please correct the problems before submitting.';
      const fields = form.querySelector('.fields:first-child');
      const fieldsParent = fields.parentNode;
      fieldsParent.insertBefore(errorMsg, fields);
    }

    if(invalidCallback) {
      invalidCallback();
    }

    window.scrollTo(0, 0);
  }
}

// Convert minutes to hours
export function toHours(time, isFirst, textOnly, unabbreviated, showLabel) {
  let hours = 'hr';
  let minutes = 'min';

  if (unabbreviated) {
    hours = ' hour';
    minutes = ' minute';
  }

  if (time >= 30) {
    if (isFirst) {
      if (textOnly) {
        return time / 60
      } else {
        if(showLabel) {
          return (
            <span>{time / 60} {hours}</span>
          )
        } else {
          return (
            <span>{time / 60}</span>
          )
        }
      }
    } else {
      if (parseInt(time / 60, 10) > 1 && unabbreviated) {
        hours = ' hours';
      }

      if(unabbreviated) {
        minutes = 'minutes';
      }

      if (textOnly) {
        let minuteText = time % 60 > 0 ? ` ${time % 60} ${minutes}` : '';

        return parseInt(time / 60, 10) + hours + minuteText;
      } else {
        return (
          <span>
            {parseInt(time / 60, 10)} {hours}

            {time % 60 > 0 &&
              ` ${time % 60} ${minutes}`
            }
          </span>
        )
      }
    }
  } else {
    if (isFirst) {
      if (textOnly) {
        return time
      } else {
        return (
          <span>{time}</span>
        )
      }
    } else {
      if (time > 1) {
        minutes = ' minutes';
      }

      if (textOnly) {
        return time + ' ' + minutes
      } else {
        return (
          <span>
            {time} {minutes}
          </span>
        )
      }
    }
  }
}

// Scroll to top of element
export function toTop(element) {
  if (element) {
    element.scrollTop = 0;
  } else {
    window.scrollTo(0, 0);
  }
}

// Confirm
export function confirm(msg, func) {
  SessionStore.showConfirm(msg, func);
}

// Prompt
export function promptUser(msg, selectFunc, callback) {
  SessionStore.showPrompt(msg, selectFunc, callback);
}

// Round time
export function roundTime(time) {
  if (time && time.minute() !== 0 && time.minute() !== 30) {
    const remainder = 30 - time.minute() % 30;
    return moment.utc(time).local().add('minutes', remainder).format('HH:mm');
  }

  return moment.utc(time).local().format('HH:mm');
}

/**
 * Get static map url from google maps API for a given <latitude, longitude> pair
 * @export
 * @param {number} latitude
 * @param {number} longitude
 * @returns {string}
 */
export function getMapUrl(latitude, longitude) {
  return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}` +
    `&zoom=16&scale=2&size=400x250&maptype=roadmap&key=${config.mapsApiKey}` +
    `&format=png&visual_refresh=true&markers=icon:${config.domain}/static/img/marker.png%7C${latitude},${longitude}`;
}

/**
 * Get URL segments
 * @export
 * @param {Component} component
 * @param {number} segment
 */
export function getURLSegment(component, segment) {
  const { pathname } = component.props.routing.location;

  let pathArray = pathname.split('/');

  if (pathArray[0] === '') {
    pathArray.splice(0, 1);
  }

  return pathArray[segment - 1];
}

/**
 * Push the href, usually received from a html element event, to routing history
 * @export
 * @param {string} href
 * @param {Component} component
 */
export function pushHrefToRouting(href, component) {
  // Regex to grab the domain name part of url
  // For example grab 'http://www.url.com/' from 'http://www.url.com/page'
  let domainRegex = /^(?:\/\/|[^\/]+)*\//;

  // Replace the domain name and the '#' with empty string because the react router excludes them from path
  // For example 'http://www.url.com/#/page' becomes '/page'
  let path = href
    .replace(domainRegex, '')
    .replace('#', '');

  // Push the path to routing if it's not there already
  if (component.props.routing.location.pathname !== path) {
    component.props.routing.history.push(path);
  }
}

/**
 * Get query params from a string
 * @export
 * @param {name} string
 * @param {url} string
 */
export function getParam(name, url) {
  name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  let results = regex.exec(url);

  if(!results) {
    return null;
  }

  if(!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/**
* Find ancestor by class
* @export
* @param {el} string
* @param {className} string
*/
export function findAncestor (el, className) {
  while (el.parentNode) {
    el = el.parentNode;

    if(el && el.className.indexOf(className) > -1) {
      return el;
    }
  }

  return null;
}

/**
* Flag portrait oriented image
* @export
* @param {e} string
* @param {src} string
*/
export function flagPortrait(e, src) {
  const img = new Image();
  const imgEl = e.target;
  let width = 0;
  let height = 0;

  img.onload = function(){
    width = img.width;
    height = img.height;

    if(height > width) {
      imgEl.className += ' portrait';
    }
  }

  img.src = src;
}

/**
* Check if sessionStorage is available
* @export
*/
export function isLocalStorageSupported() {
  const testKey = 'test';
  const storage = window.sessionStorage;

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  }
  catch (error) {
    return false;
  }
}

/**
* Get cookie by name
* @export
* @param {name} string
*/
export function getCookie(name) {
  const match = document.cookie.match(new RegExp(name + '=([^;]+)'));

  if(match) {
    return match[1]
  }
}

/**
* Delete cookie by name
* @export
* @param {name} string
*/
export function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * Get url path and query from a string
 * @export
 * @param {url} string
 */
export function getPath(url) {
  const parser = document.createElement('a');
  parser.href = url;
  const pathname = parser.pathname;
  const search = parser.search;

  return pathname + search;
}

/**
* Format time as h:mm
* @export
* @param {duration} integer (minutes)
*/
export function formatTime(duration) {
  let minutes = duration % 60;
  let hours = Math.floor(duration / 60);

  if(minutes < 10) {
    minutes = '0' + minutes;
  }

  return `${hours}:${minutes}`;
}

/**
* Extract time from date
* @param {time} string
*/
export function extractTime(time) {
  const { userTimezone } = SessionStore;

  if(moment(time, moment.ISO_8601).isValid()) {
    return moment.utc(time).tz(userTimezone).format('HH:mm');
  } else {
    return '';
  }
}

/**
* Check if input type is supported
* @export
* @param {type} string
*/
export function checkInput(type) {
  let input = document.createElement('input');
  input.setAttribute('type', type);
  return input.type === type;
}

/**
 * Check if any ancestor has a given class
 *
 * @exports
 * @function parentHasClass
 * @param {element} child
 * @param {string} classname
 * @returns {boolean}
 */
export function parentHasClass(child, className) {
  if(child.classList && child.classList.contains(className)) {
    return true;
  }

  return child.parentNode && parentHasClass(child.parentNode, className);
}



// WEBPACK FOOTER //
// ./src/app/helpers/helpers.js